import { render, staticRenderFns } from "./PagePad.vue?vue&type=template&id=4088643e&scoped=true&"
import script from "./PagePad.vue?vue&type=script&lang=js&"
export * from "./PagePad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088643e",
  null
  
)

export default component.exports